import { useCallback, useEffect, useState } from 'react';
import { newMultiRangeRow, type MultiRangeRow } from './multiRangeRowModel';

export function useMultiRangeRows(open: boolean, initialRange?: { from: string; to: string }) {
  const newRow = useCallback(
    () => ({
      ...newMultiRangeRow(initialRange?.from),
      to: initialRange?.to ?? initialRange?.from ?? new Date().toISOString().slice(0, 10),
    }),
    [initialRange?.from, initialRange?.to],
  );
  const [rows, setRows] = useState<MultiRangeRow[]>(() => [newRow(), newRow(), newRow()]);

  useEffect(() => {
    if (open) {
      setRows([newRow(), newRow(), newRow()]);
    }
  }, [newRow, open]);

  return {
    rows,
    patchRow: (id: string, patch: Partial<MultiRangeRow>) =>
      setRows((previous) => previous.map((row) => (row.id === id ? { ...row, ...patch } : row))),
    addRow: () => setRows((previous) => [...previous, newMultiRangeRow()]),
    removeRow: (id: string) =>
      setRows((previous) =>
        previous.length > 1 ? previous.filter((row) => row.id !== id) : previous,
      ),
    replaceRows: (next: MultiRangeRow[]) => setRows(next),
  };
}
